import React from "react";

import { useIntl } from "react-intl";

import Button from "ds/Button";

import * as S from "./AuthenticationNameBox.styles";

type AuthenticationNameBoxProps = {
  name?: string;
  avatarUrl?: string;
  onClickChangeToken?: (e: React.MouseEvent) => void;
};

const AuthenticationNameBox = ({
  name,
  avatarUrl,
  onClickChangeToken
}: AuthenticationNameBoxProps) => {
  const intl = useIntl();

  return (
    <S.AuthenticationNameBox>
      <S.AvatarBox>
        <S.Avatar
          userName={name ?? ""}
          userImage={avatarUrl}
          size="large"
          withToolTip
        />
        <S.AvatarText>
          {intl.formatMessage(
            {
              id: "integration.configure.field.info.authenticated_as",
              defaultMessage: "Authenticated as"
            },
            {
              b: chunks => <b>{chunks}</b>,
              name: name
            }
          )}
        </S.AvatarText>{" "}
      </S.AvatarBox>
      <Button
        variant="link"
        analyticId="integration.configure.field.info.change_token"
        onClick={onClickChangeToken}
      >
        {intl.formatMessage({
          id: "integration.configure.field.info.change_token"
        })}
      </Button>
    </S.AuthenticationNameBox>
  );
};

export default AuthenticationNameBox;
